// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"GamePromptModal_modalWrapper__owiRW","promptText":"GamePromptModal_promptText__3PL5W"};